import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/supplier-returns')({
  staticData: { crumb: 'supplierReturns' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'purchasing.read'),
  component: Outlet,
})
